import { Pipe, Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpClient } from "@angular/common/http";
import 'rxjs/add/operator/map';
import { PermissionModel } from '../models/permission.model';
@Pipe({ name: 'PermissionService' })

@Injectable()
export class PermissionService {

  constructor(private httpClient: HttpClient) { }

  createPermission(permissionIdList: Array<any>, permissionSetName: string, permissionSetCode: string, permissionSetDescription: string) {
    let url = localStorage.getItem('ApiEndPoint') + '/api/auth/createPermission';
    return this.httpClient.post(url, { PermissionIdList: permissionIdList, PermissionSetName: permissionSetName, PermissionSetCode: permissionSetCode, PermissionSetDescription: permissionSetDescription })
      .map((response: Response) => {
        return response;
      });
  }

  editPermissionById(permissionSetId: string, permissionSetName: string, permissionSetDes: string, permissionSetCode: string, permissionIdList: Array<any>) {
    let url = localStorage.getItem('ApiEndPoint') + '/api/auth/editPermissionById';
    return this.httpClient.post(url, { PermissionSetId: permissionSetId, PermissionSetName: permissionSetName, PermissionSetDescription: permissionSetDes, PermissionSetCode: permissionSetCode, PermissionIdList: permissionIdList })
      .map((response: Response) => {
        return response;
      });
  }

  deletePermissionById(permissionSetId: string) {
    let url = localStorage.getItem('ApiEndPoint') + '/api/auth/deletePermissionById';
    return this.httpClient.post(url, { PermissionSetId: permissionSetId })
      .map((response: Response) => {
        return response;
      });
  }

  getPermissionById(permissionSetId: string) {
    let url = localStorage.getItem('ApiEndPoint') + '/api/auth/getPermissionById';
    return this.httpClient.post(url, { PermissionSetId: permissionSetId })
      .map((response: Response) => {
        return response;
      });
  }

  getAllPermission() {
    let url = localStorage.getItem('ApiEndPoint') + '/api/auth/getAllPermission';
    return this.httpClient.post(url, {})
      .map((response: Response) => {
        return response;
      });
  }

  getPermissionByCode(code: Array<any>) {
    let url = localStorage.getItem('ApiEndPoint') + '/api/auth/getPermissionByCode';
    return this.httpClient.post(url, { PerCode: code })
      .map((response: Response) => {
        return response;
      });
  }

  getModuleByPermissionSetId(permissionSetId: string) {
    let url = localStorage.getItem('ApiEndPoint') + '/api/auth/getModuleByPermissionSetId';
    return this.httpClient.post(url, { PermissionSetId: permissionSetId })
      .map((response: Response) => {
        return response;
      });
  }

  getAllPermissionSetNameAndCode() {
    let url = localStorage.getItem('ApiEndPoint') + '/api/auth/getAllPermissionSetNameAndCode';
    return new Promise((resolve, reject) => {
      return this.httpClient.post(url, {}).toPromise()
        .then((response: Response) => {
          resolve(response);
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/permission.service.ts